module.exports = __webpack_public_path__ + "img/tarj-jav.be637057.jpg";